import { useMemo, useState } from 'react';
import { useAppData } from '../store';
import { buildCategoryYearMatrix } from '../lib/expenses';
import { formatUSD } from '../lib/format';
import { EXPENSE_CATEGORY_LABELS } from '../types';

export default function ReportsView() {
  const { expenses, properties } = useAppData();
  const [propertyFilter, setPropertyFilter] = useState<string | 'all'>('all');

  const filtered = useMemo(
    () =>
      propertyFilter === 'all'
        ? expenses
        : expenses.filter((e) => e.property_id === propertyFilter),
    [expenses, propertyFilter]
  );

  const matrix = useMemo(() => buildCategoryYearMatrix(filtered), [filtered]);

  return (
    <div className="reports-view">
      <div className="page-header">
        <h1>Reports</h1>
      </div>

      <div className="filter-row">
        <select value={propertyFilter} onChange={(e) => setPropertyFilter(e.target.value)}>
          <option value="all">All properties</option>
          {properties.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>
      </div>

      <p className="muted" style={{ fontSize: 13, marginBottom: 10 }}>
        Fiscal years run Sept 1 – Aug 31.
      </p>

      {matrix.rows.length === 0 ? (
        <p className="muted empty">No expenses logged yet.</p>
      ) : (
        <div className="report-table-wrap">
          <table className="report-table">
            <thead>
              <tr>
                <th>Category</th>
                {matrix.years.map((y) => (
                  <th key={y}>FY{y}</th>
                ))}
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {matrix.rows.map((row) => (
                <tr key={row.category}>
                  <td>{EXPENSE_CATEGORY_LABELS[row.category]}</td>
                  {matrix.years.map((y) => (
                    <td key={y} className={row.byYear[y] ? '' : 'muted'}>
                      {row.byYear[y] ? formatUSD(row.byYear[y]) : '—'}
                    </td>
                  ))}
                  <td className="report-total-cell">{formatUSD(row.total)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td>Total</td>
                {matrix.years.map((y) => (
                  <td key={y}>{formatUSD(matrix.yearTotals[y])}</td>
                ))}
                <td className="report-total-cell">{formatUSD(matrix.grandTotal)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
}
